import type { IconNode } from '../types';

/**
 * @name jug
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTkgMy0yIDVINUwzIDNoMTZaIiAvPgogIDxwYXRoIGQ9Ik0xOSAzYzEuNyAwIDMgMS4zIDMgM3Y0IiAvPgogIDxwYXRoIGQ9Ik0yIDE2YzEuMDgtLjUgMi4xNi0xIDQuNS0xIDQuNSAwIDQuNSAyIDkgMiAyLjM0IDAgMy40Mi0uNSA0LjUtMSIgLz4KICA8cGF0aCBkPSJNMTUgMjFhNSA1IDAgMCAwIDQuNDgtNy4yMkwxNyA4SDVsLTIuNSA1LjhBNSA1IDAgMCAwIDcgMjFaIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/jug
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const jug: IconNode = [
  ['path', { d: 'm19 3-2 5H5L3 3h16Z', key: '35ctia' }],
  ['path', { d: 'M19 3c1.7 0 3 1.3 3 3v4', key: '1g037u' }],
  ['path', { d: 'M2 16c1.08-.5 2.16-1 4.5-1 4.5 0 4.5 2 9 2 2.34 0 3.42-.5 4.5-1', key: '1t58x4' }],
  ['path', { d: 'M15 21a5 5 0 0 0 4.48-7.22L17 8H5l-2.5 5.8A5 5 0 0 0 7 21Z', key: '2wgiqg' }],
];

export default jug;
